module.exports = __webpack_public_path__ + "static/media/radioCurrent.6479e0e6.svg";